import { useMutation } from "react-query";
import { getSafeSessionConfig } from "../utils/getSafeSessionConfig";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useConfig } from "../../utils/useConfig";
import { toast } from "react-toastify";
import { useData } from "../../utils/useData";
import { deleteUser } from "../../mutations/users/deleteUser";

export const useDeleteUser = (options?: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}) => {
    const { config } = useConfig();
    const { getToken } = useKindeAuth();
    const { employees, accounts, employerId } = useData();

    return useMutation(async (employeeId: string) => {
            const { API_URL, token } = await getSafeSessionConfig(config, getToken);
            await deleteUser(API_URL, token, employerId, employeeId);
        },
        {
            onSuccess: () => {
                toast.success("User deleted successfully");
                employees.refetch();
                accounts.refetch();
                options?.onSuccess?.();
            },
            onError: (error: Error) => {
                console.error(error.message);
                toast.error(error.message);
                options?.onError?.(error);
            }
        }
    )
}